<template>
    <card-list-item no-hover no-cursor>
        <template v-slot:icon><i class="fad fa-note fa-fw"></i></template>
        <template v-slot:content>
            <div class="meta">{{note.portal_users.first_name}} {{note.portal_users.last_name}}</div>
            <div class="meta mb-4">{{note.created_at | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</div>
            <div class="mb-4 note content" v-html="note.note"></div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'PlanNoteTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            note: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                details: false,
            }
        },
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .note {
        padding: 1.5rem;
        border: 1px solid #e7e7e7;
        border-radius: 1rem;
        background: white;
        font-size: 0.9rem;
    }
</style>
